var render = function () {
  var _vm$value, _vm$value$type, _vm$value3, _vm$value3$type, _vm$deliveryDate, _vm$value$deliveryDat;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Form', {
    staticClass: "delivery",
    attrs: {
      "adaptive-on900": "",
      "data-e2e": "delivery"
    }
  }, [_c('UIDataEntity', {
    attrs: {
      "get": _vm.$api.location.getCitiesWithCache
    },
    on: {
      "success": _vm.onCityListLoad
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$city;

        var loading = _ref.loading;
        return [_c('FormElement', {
          attrs: {
            "title": "Город:"
          }
        }, [_c('Select', {
          attrs: {
            "data": _vm.cityList,
            "value": (_vm$city = _vm.city) === null || _vm$city === void 0 ? void 0 : _vm$city.id,
            "loading": loading,
            "loading-open-select": false,
            "placeholder": "Выберите город",
            "search": "",
            "visible-empty-option": false
          },
          on: {
            "change": _vm.onCityChange
          }
        })], 1)];
      }
    }])
  }), _vm._v(" "), _c('FormElement', {
    attrs: {
      "title": "Тип доставки:"
    }
  }, [_c('OrderTypeSelect', {
    attrs: {
      "list": _vm.list,
      "delivery-view": "",
      "value": (_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$type = _vm$value.type) === null || _vm$value$type === void 0 ? void 0 : _vm$value$type.id,
      "name": "delivery-type"
    },
    on: {
      "change": _vm.onTypeChange
    }
  })], 1), _vm._v(" "), _c('FormElement', {
    staticClass: "delivery-address",
    attrs: {
      "title": "Адрес доставки:",
      "hint-min-height": "auto"
    }
  }, _vm._l(_vm.list, function (t) {
    var _vm$value2;

    return _c('div', {
      key: t.id
    }, [_vm.isActive(t.id) ? _c(t.allowSelectUserAddress ? 'CourierAddressSelect' : 'PickupAddressSelect', {
      tag: "div",
      attrs: {
        "list": t.list,
        "value": (_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : _vm$value2.address,
        "city": _vm.city
      },
      on: {
        "update": function ($event) {
          return _vm.onChange({
            address: $event
          });
        }
      }
    }) : _vm._e()], 1);
  }), 0), _vm._v(" "), _vm.isMakhachkala && ((_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : (_vm$value3$type = _vm$value3.type) === null || _vm$value3$type === void 0 ? void 0 : _vm$value3$type.code) === 'DELIVERY' ? _c('FormElement', {
    staticClass: "delivery-intervals"
  }, [_c('h2', {
    staticClass: "h2 mb-18 delivery-intervals__title"
  }, [_vm._v("\n      Когда доставить заказ?\n    ")]), _vm._v(" "), !((_vm$deliveryDate = _vm.deliveryDate) !== null && _vm$deliveryDate !== void 0 && _vm$deliveryDate.length) ? _c('Note', {
    attrs: {
      "size": "m"
    }
  }, [_vm._v("\n      Дату и время доставки рассчитает и сообщит оператор\n    ")]) : [_vm.dateIntervals ? _c('TSRadioListSelect', {
    staticClass: "mt-20 mb-10",
    attrs: {
      "model-value": (_vm$value$deliveryDat = _vm.value.deliveryDate) !== null && _vm$value$deliveryDat !== void 0 ? _vm$value$deliveryDat : undefined,
      "list": _vm.dateIntervals,
      "name": "delivery-time"
    },
    on: {
      "update:model-value": function ($event) {
        _vm.onChange({
          deliveryDate: $event.value.toString()
        });

        $event.value && _vm.emitter.emit('click-delivery-date', {
          date: $event.value.toString()
        });
        _vm.selectedInterval = $event.index || 0;
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.timeIntervals && _vm.value.deliveryDate ? _c('Select', {
    staticClass: "delivery__time",
    attrs: {
      "data": _vm.timeIntervals,
      "placeholder": "Выберите время"
    },
    on: {
      "change": function ($event) {
        _vm.onChange({
          deliveryTime: $event
        }), $event && _vm.emitter.emit('click-delivery-time');
      }
    }
  }) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), _c('Toggle', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var onClick = _ref2.onClick,
            isActive = _ref2.isActive;
        return [_c('span', {
          staticClass: "delivery__another-man link link_dashed fz-14",
          on: {
            "click": onClick
          }
        }, [_vm._v("Получатель, другой человек")]), _vm._v(" "), isActive ? _c('div', {
          staticClass: "mt-12"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "ФИО другого получателя"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var _vm$value4;

              var errors = _ref3.errors,
                  validate = _ref3.validate;
              return [_c('FormElement', {
                attrs: {
                  "title": "ФИО:",
                  "error": errors[0]
                }
              }, [_c('InputText', {
                attrs: {
                  "value": (_vm$value4 = _vm.value) === null || _vm$value4 === void 0 ? void 0 : _vm$value4.recipient
                },
                on: {
                  "input": function ($event) {
                    validate($event);

                    _vm.onChange({
                      recipient: $event
                    });
                  }
                }
              })], 1)];
            }
          }], null, true)
        }), _vm._v(" "), _c('ValidationProvider', {
          attrs: {
            "rules": "required|phone",
            "name": "телефон другого получателя"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref4) {
              var _vm$value5;

              var errors = _ref4.errors,
                  validate = _ref4.validate;
              return [_c('FormElement', {
                attrs: {
                  "title": "Телефон:",
                  "error": errors[0]
                }
              }, [_c('InputText', {
                attrs: {
                  "value": (_vm$value5 = _vm.value) === null || _vm$value5 === void 0 ? void 0 : _vm$value5.recipientPhone
                },
                on: {
                  "input": function ($event) {
                    validate($event);

                    _vm.onChange({
                      recipientPhone: $event
                    });
                  }
                }
              })], 1)];
            }
          }], null, true)
        })], 1) : _vm._e()];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }